import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import IconButton from "@mui/material/IconButton";
import { useHorizontalScroll } from "../../Hooks";
import { ResGrad } from "../../Components/interface";

export interface tier {
  name: string;
  label: string;
  description: string;
}

export interface ScrollableInterface {
  tier: tier;
  items: ResGrad | undefined;
}

export const ScrollableList = ({ tier, items }: ScrollableInterface) => {
  const {
    containerRef,
    showArrows,
    canScrollLeft,
    canScrollRight,
    checkScroll,
    startScrolling,
    stopScrolling,
    handleImageLoad,
  } = useHorizontalScroll();

  const handleLinkClick = async (name: string, type: string, url: string) => {
    if (url !== "") {
      window.open(url, "_blank");
      traceLink(name, type, url);
    }
  };

  const traceLink = async (name: string, type: string, url: string) => {
    try {
      if (name !== "" && type !== "") {
        await fetch("/v1/api/fetchAttr", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ name, type }),
        });
      }
    } catch (error) {
      console.error("click error:", error);
    }
  };

  return (
    <div className={"row " + tier.name}>
      <div className={"flex-column fixed-column " + tier.name}>
        {tier.label}
        <span className="text-[8px] font-[100]">{tier.description}</span>
      </div>
      {showArrows && (
        <IconButton
          style={{
            position: "absolute",
            backgroundColor: "#fb8500",
            boxShadow: "1px 3px 6px -2px #000000",
          }}
          className="scrollLeft left-[175px] w-[38px] z-10"
          onMouseDown={() => canScrollLeft && startScrolling("left")}
          onMouseUp={stopScrolling}
          onMouseLeave={stopScrolling}
          onTouchStart={() => canScrollLeft && startScrolling("left")}
          onTouchEnd={stopScrolling}
        >
          <ChevronLeftIcon style={{ color: "#ffffff" }} />
        </IconButton>
      )}
      <ul className="images" ref={containerRef}>
        {items?.payload.map((item, index) => {
          if (item.grad === tier.name) {
            return (
              <li key={index} className="position-relative">
                <div className="tiers-portfolio-img  bg-white-opacity">
                  <img
                    className="grow"
                    src={
                      "/images/nfts/" +
                      (item.image_url !== "" ? item.collection : "no-image") +
                      ".png"
                    }
                    onLoad={handleImageLoad}
                  ></img>
                  <div className="portfolio-icon">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick(
                          item.collection,
                          "opensea",
                          "https://opensea.io/collection/" + item.collection,
                        );
                      }}
                    >
                      {item.name}
                    </a>
                    <div className="flex justify-center gap-[3px]">
                      {item?.twitter_url && (
                        <a
                          href={"#"}
                          title={"Twitter"}
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClick(
                              item.collection,
                              "twitter",
                              "https://x.com/" + item.twitter_url,
                            );
                          }}
                        >
                          <i
                            className="fab fa-twitter text-extra-dark-gray fa-lg hover:decoration-[#fb8500]"
                            aria-hidden="true"
                          ></i>
                        </a>
                      )}
                      {item?.discord_url && (
                        <a
                          href={"#"}
                          title={"Discord"}
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClick(
                              item.collection,
                              "discord",
                              item.discord_url,
                            );
                          }}
                        >
                          <i
                            className="fab fa-discord text-extra-dark-gray fa-lg"
                            aria-hidden="true"
                          ></i>
                        </a>
                      )}
                      {item?.telegram_url && (
                        <a
                          href={"#"}
                          title={"Telegram"}
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClick(
                              item.collection,
                              "telegram",
                              item.telegram_url,
                            );
                          }}
                        >
                          <i
                            className="fab fa-telegram text-extra-dark-gray fa-lg"
                            aria-hidden="true"
                          ></i>
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </li>
            );
          }
        })}
      </ul>
      {showArrows && (
        <IconButton
          style={{
            position: "absolute",
            backgroundColor: "#fb8500",
            boxShadow: "1px 3px 6px -2px #000000",
          }}
          className="scrollRight right-[20px] w-[38px] z-10"
          onMouseDown={() => canScrollRight && startScrolling("right")}
          onMouseUp={stopScrolling}
          onMouseLeave={stopScrolling}
          onTouchStart={() => canScrollRight && startScrolling("right")}
          onTouchEnd={stopScrolling}
          disabled={!canScrollRight}
          aria-label="Scroll right"
        >
          <ChevronRightIcon style={{ color: "#ffffff" }} />
        </IconButton>
      )}
    </div>
  );
};
